import { Component, Input, OnInit } from '@angular/core';
import { LayoutConfigService } from '../../services/layout-config.service';
import { CommonModule } from '@angular/common';
import { InputType } from '../app-input/app-input.component';
import { RankingService } from 'src/app/core/services/ranking.service';
import { ReplaceTextPipe } from "../../pipe/replace-text.pipe";

@Component({
  selector: 'app-ranking-table',
  standalone: true,
  imports: [
    CommonModule,
    ReplaceTextPipe
  ],
  templateUrl: './ranking-table.component.html',
  styleUrl: './ranking-table.component.scss'
})
export class RankingTableComponent implements OnInit {
  InputTypeEnum = InputType;
  rows: any[] = [];
  @Input() tableConfig: any;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private rankingService: RankingService
  ) { }

  public styles: { [key: string]: any };
  public buttonOptions: any;

  ngOnInit(): void {
    const layoutVersion = this.layoutConfigService.getLayoutVersion();
    this.styles = {
      '--border-radius': layoutVersion === 1 ? '15px' : '0px'
    };

    this.rankingService.getMemberRanking().subscribe(res => {
      this.rows = res.content;
    })
  }
}

interface Row {
  ranking: number;
  photo: string;
  socio: string;
  cidade: string;
  pontos: number;
  trend?: 'up' | 'down';
}
